import React from "react";
import {ArrowBack, ArrowForward, CalendarToday} from "@mui/icons-material";
import {Button, ButtonGroup, Menu, MenuItem, Paper, Toolbar, Typography} from "@mui/material";
import CalendarioViewMenu from "./CalendarioViewMenu";
import CalendarioActionMenu from "./CalendarioActionMenu";
import CalendarioMesPanel from "./CalendarioMesPanel";
import Service from "../../../util/Service";
import EventoDialog from "./EventoDialog";
import CalendarioSemanaPanel from "./CalendarioSemanaPanel";
import CalendarioDiaPanel from "./CalendarioDiaPanel";
import EventoFormDialog from "./EventoFormDialog";

export default function CalendarioPanel() {
    const [data, setData] = React.useState(new Date());
    const [calendarType, setCalendarType] = React.useState("mensal");
    const [eventos, setEventos] = React.useState([]);
    const [showEvento, setShowEvento] = React.useState(false);
    const [idEvento, setIdEvento] = React.useState();
    const [feriado, setFeriado] = React.useState();

    React.useEffect(() => {
        goToHoje();
        buscaTodos();
    }, []);

    React.useEffect(() => {
        if (data) {
            const ano = data.getFullYear();
            if (!feriado || (feriado && feriado.ano !== ano)) {
                buscaFerias(ano);
            }
        }
    }, [data])

    function buscaTodos() {
        Service.GET("/api/security/eventoTodos").then(r => {
            console.log( r)
            setEventos(r);
        })
    }

    function buscaFerias(ano) {
        Service.GET("https://brasilapi.com.br/api/feriados/v1/" + ano).then(r => {
            const f = {
                ano: ano,
                lst: (typeof r === "string") ? JSON.parse(r) : r
            }
            setFeriado(f);
        })
    }

    function formataData() {
        const mesAno = data.toLocaleDateString('pt-BR', {month: 'long', year: 'numeric'});
        return mesAno.charAt(0).toUpperCase() + mesAno.slice(1);
    }

    function handleGoBack() {
        if (calendarType === 'mensal') {
            let dt = new Date(data);
            dt.setMonth(dt.getMonth() - 1);
            dt.setHours(0, 0, 0, 0);
            console.log('>>>handleGoBack<<<', dt.toLocaleDateString())
            setData(dt);
        } else if (calendarType === 'semanal') {
            let dt = new Date(data);
            // dt.setMonth(dt.getMonth() - 1);
            dt.setDate(dt.getDate() - 7);
            dt.setHours(0, 0, 0, 0);
            console.log('>>>handleGoBack<<<', dt.toLocaleDateString())
            setData(dt);
        } else if (calendarType === 'diario') {
            let dt = new Date(data);
            dt.setDate(dt.getDate() - 1);
            console.log('>>>handleGoBack<<<', dt.toLocaleDateString())
            setData(dt);
        }
    }

    function handleGoForward() {
        if (calendarType === 'mensal') {
            let dt = new Date(data);
            dt.setMonth(dt.getMonth() + 1);
            dt.setHours(0, 0, 0, 0);
            console.log('>>>handleGoForward<', dt.toLocaleDateString())
            setData(dt);
        } else if (calendarType === 'semanal') {
            let dt = new Date(data);
            dt.setDate(dt.getDate() + 7);
            dt.setHours(0, 0, 0, 0);
            console.log('>>>handleGoForward<<<', dt.toLocaleDateString())
            setData(dt);
        } else if (calendarType === 'diario') {
            let dt = new Date(data);
            console.log('>>>handleGoForward<<<', dt.toLocaleDateString())
            dt.setDate(dt.getDate() + 1);
            setData(dt);
        }
    }

    function goToHoje() {
        let dt = new Date();
        dt.setHours(0, 0, 0, 0);
        setData(dt);
    }

    return (
        <Paper sx={{p: 1, m: 1}}>
            <Toolbar sx={{
                '@media (min-width: 600px)': {
                    minHeight: '45px',
                },
            }}
            >
                <ButtonGroup variant="outlined" aria-label="Basic button group" size="small">
                    <Button startIcon={<ArrowBack/>} onClick={handleGoBack}/>
                    <Button endIcon={<ArrowForward/>} onClick={handleGoForward}/>
                </ButtonGroup>
                <Button endIcon={<CalendarToday/>} onClick={goToHoje}>
                    Hoje
                </Button>

                <Typography align="center" sx={{ml: 2, flex: 1}} variant="h6" component="div">
                    {formataData()}
                </Typography>
                <CalendarioViewMenu type={calendarType} setType={setCalendarType}/>
                <CalendarioActionMenu
                    action={buscaTodos}
                    type={calendarType}
                    data={data}
                    eventos={eventos}
                />
            </Toolbar>
            {calendarType === 'mensal' &&
                <CalendarioMesPanel data={data} eventos={eventos} setShowEvento={setShowEvento}
                                    setIdEvento={setIdEvento} feriado={feriado}
                                    setData={setData}
                                    setCalendarType={setCalendarType}/>}

            {calendarType === 'semanal' &&
                <CalendarioSemanaPanel
                    data={data} eventos={eventos} setShowEvento={setShowEvento} setIdEvento={setIdEvento}
                    feriado={feriado}
                />
            }
            {calendarType === 'diario' && (
                <CalendarioDiaPanel
                    data={data}
                    eventos={eventos}
                    setShowEvento={setShowEvento}
                    setIdEvento={setIdEvento}
                    feriado={feriado}
                />
            )}
            {(calendarType !== 'mensal' && calendarType !== 'semanal' && calendarType !== 'diario') &&
                <p>não implementado</p>}

            <EventoDialog
                open={showEvento} setOpen={setShowEvento} idEvento={idEvento}
            />

        </Paper>
    )
}